<!-- 电能数据 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        class="table-wrap"
        shadow="never"
        body-style="{ height: calc(100vh - 60px - 40px - 32px - 40px)}"
      >
        <template #header>
          <el-form inline>
            <el-row :gutter="15" class="mt20">
              <el-col :span="3.5">
                <el-form-item label="类别:" label-width="80px">
                  <el-button-group>
                    <el-button
                      :type="dateType === 'day' ? 'primary' : ''"
                      @click="dateType = 'day'"
                    >{{ $t("text.r") }}</el-button>
                    <el-button
                      :type="dateType === 'week' ? 'primary' : ''"
                      @click="changeDateType"
                    >周</el-button>
                    <el-button
                      :type="dateType === 'month' ? 'primary' : ''"
                      @click="dateType = 'month'"
                    >{{ $t("text.y") }}</el-button>
                  </el-button-group>
                </el-form-item>
              </el-col>
              <el-col v-show="dateType === 'day'" :span="5">
                <el-form-item label="开始时间" label-width="80px">
                  <el-date-picker
                    v-model="startTime"
                    format="yyyy-MM-dd 00:00:00"
                    type="date"
                  />
                </el-form-item>
              </el-col>
              <el-col v-show="dateType === 'day'" :span="5">
                <el-form-item label="结束时间" label-width="80px">
                  <el-date-picker
                    v-model="endTime"
                    format="yyyy-MM-dd 23:59:59"
                    type="date"
                  />
                </el-form-item>
              </el-col>
              <el-col v-show="dateType === 'week'" :span="5">
                <el-form-item label="开始时间" label-width="80px">
                  <el-date-picker
                    v-model="startTime"
                    type="week"
                    format="yyyy 第 WW 周"
                    :picker-options="datePickerOptions"
                  />
                </el-form-item>
              </el-col>
              <el-col v-show="dateType === 'week'" :span="5">
                <el-form-item label="结束时间" label-width="80px">
                  <el-date-picker
                    v-model="endTime"
                    type="week"
                    format="yyyy 第 WW 周"
                    :picker-options="datePickerOptions"
                  />
                </el-form-item>
              </el-col>
              <el-col v-show="dateType === 'month'" :span="5">
                <el-form-item label="开始时间" label-width="80px">
                  <el-date-picker v-model="startTime" type="month" />
                </el-form-item>
              </el-col>
              <el-col v-show="dateType === 'month'" :span="5">
                <el-form-item label="结束时间" label-width="80px">
                  <el-date-picker v-model="endTime" type="month" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button
                  type="primary"
                  icon="el-icon-view"
                  style="background: #175e77; border: none"
                  @click="handleQuery"
                >{{ $t("button.yl") }}</el-button>
                <el-button
                  type="primary"
                  icon="el-icon-upload2"
                  @click="handleExport"
                >{{ $t("button.dc") }}</el-button>
                <el-button
                  type="primary"
                  icon="el-icon-setting"
                  @click="getprice"
                >{{ $t("button.sz") }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <div v-show="showtab" class="main-content column-flex">
          <div class="search-form">
            <el-form>
              <div>
                <p>尖时段</p>
                <p><img src="../../assets/icon/j1.png" alt=""></p>
                <p>{{ datas.dsharp }}kwh</p>
              </div>
              <div>
                <p>峰时段</p>
                <p><img src="../../assets/icon/f1.png" alt=""></p>
                <p>{{ datas.dpeak }}kwh</p>
              </div>
              <div>
                <p>平时段</p>
                <p><img src="../../assets/icon/p1.png" alt=""></p>
                <p>{{ datas.dflat }}kwh</p>
              </div>
              <div>
                <p>谷时段</p>
                <p><img src="../../assets/icon/g1.png" alt=""></p>
                <p>{{ datas.dvalley }}kwh</p>
              </div>
              <div>
                <p>深谷时段</p>
                <p><img src="../../assets/icon/g1.png" alt=""></p>
                <p>{{ datas.ddvalley }}kwh</p>
              </div>
              <div>
                <p>总计</p>
                <p><img src="../../assets/icon/zo.png" alt=""></p>
                <p>
                  {{
                    (datas.dsharp +
                      datas.dpeak +
                      datas.dflat +
                      datas.dvalley +
                      datas.ddvalley)
                      | Decimal
                  }}kwh
                </p>
              </div>
            </el-form>
            <div v-show="showtab" class="wrap">
              <p>{{ datas.orgname }}项目电费结算单</p>
              <p>
                {{
                  $parseTime(datas.startdate, "yyyy年MM月dd日") +
                    "——" +
                    $parseTime(datas.enddate, "yyyy年MM月dd日")
                }}
              </p>
            </div>
            <table v-show="showtab" border="1">
              <thead>
                <tr>
                  <td colspan="2">电表名称</td>
                  <td>尖电量</td>
                  <td>峰电量</td>
                  <td>平电量</td>
                  <td>谷电量</td>
                  <td>深谷电量</td>
                  <td>总电量</td>
                </tr>
              </thead>
              <tbody v-for="(item, index) in deviceelectricity" :key="index">
                <tr>
                  <td rowspan="3">
                    {{
                      item.mtype === "0"
                        ? "(光伏表)"
                        : item.mtype === "1"
                          ? "(国网表)"
                          : ""
                    }}
                    {{ item.alias }}
                    {{
                      item.billingdirection === "0"
                        ? "(反向)"
                        : item.billingdirection === "1"
                          ? "正向)"
                          : ""
                    }}
                  </td>
                  <td>原电量</td>
                  <td>{{ item.nsharp }}</td>
                  <td>{{ item.npeak }}</td>
                  <td>{{ item.nflat }}</td>
                  <td>{{ item.nvalley }}</td>
                  <td>{{ item.ndvalley }}</td>
                  <td>{{ item.ntotal }}</td>
                </tr>
                <tr>
                  <td>倍率</td>
                  <td colspan="6">{{ item.mrate }}</td>
                </tr>
                <tr>
                  <td>实际电量</td>
                  <td>{{ item.esharp }}</td>
                  <td>{{ item.epeak }}</td>
                  <td>{{ item.eflat }}</td>
                  <td>{{ item.evalley }}</td>
                  <td>{{ item.edvalley }}</td>
                  <td>{{ item.etotal }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2">实际使用光伏电量</td>
                  <td>{{ datas.dsharp }}</td>
                  <td>{{ datas.dpeak }}</td>
                  <td>{{ datas.dflat }}</td>
                  <td>{{ datas.dvalley }}</td>
                  <td>{{ datas.ddvalley }}</td>
                  <td>{{ datas.dtotal }}</td>
                </tr>
                <tr>
                  <td colspan="2">电价【请自行设置】</td>
                  <td>{{ datas.psharp }}</td>
                  <td>{{ datas.ppeak }}</td>
                  <td>{{ datas.pflat }}</td>
                  <td>{{ datas.pvalley }}</td>
                  <td>{{ datas.pdvalley }}</td>
                  <td>{{ datas.dianjia || "" }}</td>
                </tr>
                <tr>
                  <td colspan="2">电费</td>
                  <td>{{ datas.csharp }}</td>
                  <td>{{ datas.cpeak }}</td>
                  <td>{{ datas.cflat }}</td>
                  <td>{{ datas.cvalley }}</td>
                  <td>{{ datas.cdvalley }}</td>
                  <td>{{ datas.ctotal }}</td>
                </tr>
                <tr>
                  <td colspan="2">总电费</td>
                  <td colspan="6">{{ datas.summary }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <p class="duty">此结算结果仅供参考，不做法律依据</p>
      </el-card>
      <el-dialog
        :visible.sync="showAddDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        custom-class="settlement-dialog"
        title="结算设置"
        width="800px"
        append-to-body
      >
        <template slot="default">
          <el-tabs>
            <el-tab-pane label="电价设置">
              <el-form label-width="100px" style="padding: 20px;">
                <el-form-item :label="$t('text.jdldj')">
                  <el-input v-model="psharp" clearable />
                </el-form-item>
                <el-form-item :label="$t('text.fdj')">
                  <el-input v-model="ppeak" clearable />
                </el-form-item>
                <el-form-item :label="$t('text.pdj')">
                  <el-input v-model="pflat" clearable />
                </el-form-item>
                <el-form-item :label="$t('text.gdj')">
                  <el-input v-model="pvalley" clearable />
                </el-form-item>
                <el-form-item :label="$t('text.dvalley_price')">
                  <el-input v-model="pdvalley" clearable />
                </el-form-item>
                <el-form-item :label="$t('text.grid_price')">
                  <el-input v-model="gridPrice" clearable />
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="计费方向设置">
              <el-form label-width="100px">
                <el-table :data="infolist" style="border: none;" border>
                  <el-table-column label="电表名称" prop="alias" align="center" />
                  <el-table-column label="电表类型" align="center">
                    <template v-slot="scope">
                      <el-radio v-model="scope.row.mtype" label="1">国网表</el-radio>
                      <el-radio v-model="scope.row.mtype" label="0">光伏表</el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column label="计费方向" align="center">
                    <template v-slot="scope">
                      <el-radio
                        v-model="scope.row.billingdirection"
                        label="1"
                      >正</el-radio>
                      <el-radio
                        v-model="scope.row.billingdirection"
                        label="0"
                      >反</el-radio>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </template>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSubmit">{{
            $t("button.qd")
          }}</el-button>
          <el-button @click="showAddDialog = false">{{
            $t("button.qx")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GetEPrices, SetEPrices } from "@/api/Meter"
import {
  StationFeeSettlementPreview,
  StationFeeSettlementExport,
} from "@/api/Stations"
import { GetBillingDirection, SetBillingDirection } from "@/api/Device"
const dayjs = require("dayjs")

export default {
  components: {},
  data () {
    return {
      dateType: "day",
      startTime: new Date(),
      endTime: new Date(),
      showAddDialog: false,

      // 负载用电电价
      psharp: "",
      ppeak: "",
      pflat: "",
      pvalley: "",
      pdvalley: "",

      // 负载用电电价系数
      rsharp: "",
      rpeak: "",
      rflat: "",
      rvalley: "",
      rdvalley: "",

      // 上网电价
      gridPrice: "",

      deviceelectricity: [],
      datas: "",
      showtab: true,
      fullLoading: null,
      active: true,
      infolist: [],

      /** 日期选择组件配置 */
      datePickerOptions: {
        firstDayOfWeek: 1,
      },
    }
  },
  mounted () {
    const checkResult = this.checkOrgisLizhu()
    if (checkResult) {
      this.$router.replace({ name: "meter_lizhuSettlement" })
    } else {
      this.handleQuery()
    }
  },
  methods: {
    // 弹窗Tab切换
    toggle (show) {
      this.active = !show
    },

    /** 格式化查询时间范围 */
    formatQueryTimeRange () {
      let startTime = dayjs(this.startTime)
        .startOf(this.dateType)
        .format("YYYY-MM-DD HH:mm:ss")
      let endTime = dayjs(this.endTime)
        .endOf(this.dateType)
        .format("YYYY-MM-DD HH:mm:ss")
      if (this.dateType === "week") {
        startTime = dayjs(startTime)
          .add(1, "day")
          .format("YYYY-MM-DD HH:mm:ss")
        endTime = dayjs(endTime).add(1, "day").format("YYYY-MM-DD HH:mm:ss")
      }
      return {
        startTime,
        endTime,
      }
    },

    // 获取日周月数据
    handleQuery () {
      this.fullLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      const { startTime, endTime } = this.formatQueryTimeRange()
      const postParam = {
        startTime: startTime,
        endTime: endTime,
        orgId: this.$store.getters.station.id,
        dateType: this.dateType,
      }
      StationFeeSettlementPreview(postParam)
        .then(({ data }) => {
          if (!data) {
            this.$message({
              type: "error",
              message: "此时间段没有有效数据！",
              duration: 1 * 1000,
            })
            this.showtab = false
          } else {
            this.showtab = true
          }
          this.deviceelectricity = data.deviceelectricity || []
          this.datas = data || {}
        })
        .catch(() => {
          this.showtab = false
        })
        .finally(() => {
          this.fullLoading.close()
        })
    },
    // 导出结算单
    handleExport () {
      this.fullLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      const { startTime, endTime } = this.formatQueryTimeRange()
      const postParam = {
        startTime: startTime,
        endTime: endTime,
        orgId: this.$store.getters.station.id,
      }
      StationFeeSettlementExport(postParam)
        .then(({ data }) => {
          window.location.href = data
        })
        .finally(() => {
          this.fullLoading.close()
        })
    },
    // 电价设置
    setPrice () {
      SetEPrices({
        psharp: this.psharp,
        ppeak: this.ppeak,
        pflat: this.pflat,
        pvalley: this.pvalley,
        pdvalley: this.pdvalley,
        gridPrice: this.gridPrice,
        rsharp: this.rsharp,
        rpeak: this.rpeak,
        rflat: this.rflat,
        rvalley: this.rvalley,
        rdvalley: this.rdvalley,
        id: this.$store.getters.station.id,
      }).then(() => {})
    },
    // 设置周的开始日期和结束日期
    changeDateType () {
      this.dateType = "week"
      this.startTime = this.$time(new Date(), -7)
      this.endTime = new Date()
    },
    // 取消设置
    cancelset () {
      this.$message({
        type: "success",
        message: this.$t("notice.qxsz"),
        duration: 1 * 1000,
      })
      this.showAddDialog = false
    },
    // 获取电价数据
    getprice () {
      GetEPrices({ id: this.$store.getters.station.id }).then((res) => {
        this.psharp = res.data.psharp || 1
        this.ppeak = res.data.ppeak || 1
        this.pflat = res.data.pflat || 1
        this.pvalley = res.data.pvalley || 1
        this.pdvalley = res.data.pdvalley || 1
        this.gridPrice = res.data.gridPrice || 1
        this.rsharp = res.data.rsharp || 1
        this.rpeak = res.data.rpeak || 1
        this.rflat = res.data.rflat || 1
        this.rvalley = res.data.rvalley || 1
        this.rdvalley = res.data.rdvalley || 1
      })
      this.getInfoList()
      this.showAddDialog = true
    },
    // 获取计费方式信息
    getInfoList () {
      GetBillingDirection({
        id: this.$store.getters.station.id,
      }).then((res) => {
        this.infolist = res.data
      })
    },
    // 设置计费方式信息
    setInfoList () {
      this.infolist.forEach((o) => {
        o.deviceid = o.id
      })
      SetBillingDirection(this.infolist).then((res) => {
        return res
      })
    },
    // 提交按钮
    handleSubmit () {
      this.setInfoList()
      this.setPrice()
      this.$message({
        type: "success",
        message: this.$t("notice.sjszcg"),
        duration: 1 * 1000,
      })
      this.showAddDialog = false
    },
    /** 校验电站是否是骊住电站 */
    checkOrgisLizhu () {
      const org = this.$store.getters.station
      return (
        org.id ===
        (process.env.VUE_APP_LizhuOrgid || "71391e4eca3e4f68837e578f74b9a547")
      )
    },
  },
}
</script>
<style lang="stylus" scoped>
.el-card
  background-color: #1D3666
  border: none
.search-form
  .el-form
    color #fff
    background-color: #162D60
    display: flex;
    justify-content: space-around;
    padding: 15px;
.app-container
  padding 10px
  background-color: #1c2550;
.table-wrap >>>.el-card__header
  padding 0 20px
  border none
table
  border-collapse collapse
  width 100%
  text-align center
  & td
     width 350px
     height 40px
     border 1px solid #1cc197
     color #fff
.wrap
  border 1px solid #1cc197
  border-bottom none
  margin-top 30px
  text-align center
  padding 10px 0 8px 0
  color #fff
  & p:first-child
     font-size 17px
.duty
  font-size 20px
  color red
  text-align right
  padding-top 15px
>>>.el-dialog__header
  padding 0
>>>.el-tabs__nav-wrap::after
  display none
>>>.el-tabs__item
  color #fff

</style>
<style>
.settlement-dialog .el-dialog__body{
 padding: 20px;
}
</style>
